/*
 * Start designing (sections/tcs-start.liquid): the optional width of the visitor's space, carried into each
 * kind's design link so the configurator opens at that width.
 *
 * A kind with a design link for the standard or bookcase configurator opens at the width, kept within what
 * its columns allow (300 to 600 mm each, 2400 mm in all) and, for the standard one, checked by
 * tcsDesignValidator; it says when the width was kept to its narrowest or widest. A kind without one (or
 * for the dresser or media wall configurators, which ignore a width in the link) says the width is set in
 * the designer and opens as it is.
 * The width is remembered for the visit, so reopening the sheet keeps it.
 */
(() => {
  const sheet = document.querySelector('[data-tcs-start]');
  if (!sheet) return;
  const input = sheet.querySelector('[data-tcs-start-width]');
  const hint = sheet.querySelector('[data-tcs-start-hint]');
  const kinds = [...sheet.querySelectorAll('[data-tcs-start-kind]')];
  const STANDARD = 'cabinet-configurator-default';
  // configurators that open a design at the width in its link (the dresser and media wall ones don't)
  const SIZED = [STANDARD, 'cabinet-bookcase-configurator-default'];
  const COLUMN = [300, 600];
  const MOST = 2400;
  const KEY = 'tcs-start-width';
  const mm = (n) => `${n.toLocaleString('en-GB')} mm`;

  const parse = (text) => {
    const q = String(text || '').trim().replace(/^[^?]*\?/, '').replace(/#.*$/, '');
    const out = {};
    new URLSearchParams(q).forEach((v, k) => { if (k.startsWith('c.')) out[k] = v; });
    return out;
  };

  // each kind: its product address, its design (if it can take a width), the widths its columns allow
  const info = kinds.map((a) => {
    const design = parse(a.dataset.design);
    const sized = SIZED.includes(design['c.definitionId']) && design['c.cabinet.widthMm'];
    const columns = Number(design['c.cabinet.columns']) || 1;
    return {
      a,
      line: a.querySelector('[data-tcs-start-line]'),
      base: a.getAttribute('href').split('?')[0],
      design: sized ? design : null,
      min: columns * COLUMN[0],
      max: Math.min(MOST, columns * COLUMN[1]),
    };
  });

  // The link leaves out c.definitionVersion: the configurator rejects a design marked with an older version
  // (it opens its default cupboard instead), and reads an unmarked one as its current version. The saved
  // design links carry the version they were copied at, which the validator checks against its own rules.
  const unversioned = (params) => { const p = { ...params }; delete p['c.definitionVersion']; return p; };

  const link = (k, width) => {
    const params = { ...k.design, 'c.cabinet.widthMm': String(width) };
    const V = window.tcsDesignValidator;
    // the validator knows the standard configurator's rules; other designs get the column limits only
    if (V && k.design['c.definitionId'] === STANDARD) {
      const r = V.validate(params);
      if (!r.ok) return null;
      return `${k.base}?${V.query(unversioned(r.params))}`;
    }
    return `${k.base}?${new URLSearchParams(unversioned(params))}`;
  };

  const show = (width) => {
    for (const k of info) {
      k.a.setAttribute('href', k.base);
      k.line.textContent = k.a.dataset.line;
      if (!width) continue;
      if (!k.design) {
        k.line.textContent = 'Set your width in the designer';
        continue;
      }
      const w = Math.min(k.max, Math.max(k.min, width));
      const href = link(k, w);
      if (!href) continue;
      k.a.setAttribute('href', href);
      k.line.innerHTML = w === width ? `Opens at <b>${mm(w)}</b>`
        : `Opens at <b>${mm(w)}</b>, its ${w > width ? 'narrowest' : 'widest'}`;
    }
    if (hint) hint.textContent = width ? `Each design opens at ${mm(width)} where it can. Change it any time.` : hint.dataset.empty;
  };

  const read = () => {
    const n = Number(String(input.value).replace(/[^0-9]/g, ''));
    return n >= 100 && n <= 20000 ? n : 0;
  };

  if (input) {
    try {
      const saved = Number(sessionStorage.getItem(KEY));
      if (saved) input.value = saved.toLocaleString('en-GB');
    } catch (e) { /* storage blocked: start empty */ }
    input.addEventListener('input', () => {
      const width = read();
      show(width);
      try { width ? sessionStorage.setItem(KEY, String(width)) : sessionStorage.removeItem(KEY); } catch (e) { /* fine */ }
    });
    // tidy the figure once they've finished typing
    input.addEventListener('change', () => { const w = read(); if (w) input.value = w.toLocaleString('en-GB'); });
    // the validator loads alongside; apply a remembered width once it's there
    window.addEventListener('load', () => show(read()));
    show(read());
  }
})();
